import { render, staticRenderFns } from "./classParameterScreening.vue?vue&type=template&id=29a877be&scoped=true"
import script from "./classParameterScreening.vue?vue&type=script&lang=js"
export * from "./classParameterScreening.vue?vue&type=script&lang=js"
import style0 from "./classParameterScreening.vue?vue&type=style&index=0&id=29a877be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a877be",
  null
  
)

export default component.exports